export default {
    ADWORDS_RELATED_KEYWORDS: 0,
    GOOGLE_AUTOCOMPLETE: 1,
    GOOGLE_QUESTIONS: 2,
    COMPETITORS_ORGANIC: 3,
    COMPETITORS_PAID: 4,
};
